import { Heading, Stack, StackProps } from '@chakra-ui/react';
import { Show } from '@pelicargo/ui';
import { ReactNode } from 'react';

import { useCurrentRequest } from '../../hooks/useCurrentRequest';

type Props = StackProps & {
  title?: any;
  children?: ReactNode;
};

export const EmailDrawerRightPanel = ({ title, children }: Props) => {
  // shortcut, yay
  const req = useCurrentRequest();
  return (
    <Stack overflowY="auto" p={6} spacing={6}>
      <Show if={!!title}>
        <Heading as="h3" size="md">
          {title} (R{req?.request?.id})
        </Heading>
      </Show>
      {children}
    </Stack>
  );
};
